export const ToggleSectionButton = ({ sections, handleSectionChange, selectedSection }) => {
	return (
		<div className="flex p-1 min-h-10  border border-[#CDCDCD] rounded-md w-full duration-300">
			{sections.map((section, index) => (
				<button
					key={index}
					onClick={() => handleSectionChange(index)}
					className={`px-4 py-2 rounded-md z-10 text-xs font-semibold w-full duration-300  ${
						selectedSection === index ? "bg-blue-500 text-white" : " bg-transparent text-black"
					} cursor-pointer`}
				>
					{section}
				</button>
			))}
		</div>
	);
};
